import React, { Component } from 'react';
import { CURRENCY  } from '../libs/utils/Const';
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class GrossProfitModal extends Component {

    HideGrossProfitModal = () => {
        const { GrossProfitTools } = this.props
        GrossProfitTools.HideGrossProfitModal()
    }

    OnChangePriceList = (event) => {
        const { GrossProfitTools } = this.props
        GrossProfitTools.OnchangePriceList(event);
    }

    render() {
        const { GrossProfitTools, PointOfSale = false } = this.props;
        return (
            <div>
                <div className="modal fade" id="grossProfitModal" data-backdrop="static" tabIndex="-1" aria-labelledby="grossProfitModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl modal-dialog-centered" >
                        <div className="modal-content">
                            {/* <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> */}
                            <div className="modal-body">
                                <div className="row">
                                    <div className='col-10 col-md-9'>
                                        <h4 className="modal-title ml-4">Ganancia Bruta</h4>
                                    </div>
                                    <div className='col-2 col-md-3'>
                                        <button type="button" className="close" aria-label="Close" onClick={() => this.HideGrossProfitModal()} style={{ color: "black" }}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="container-fluid mt-3">
                                    <div className='row'>
                                        <div className='col-12 col-md-4'></div>
                                        <div className='col-12 col-md-4 text-center'>
                                            {!!GrossProfitTools.Action && (GrossProfitTools.Action === 1 || (!PointOfSale && GrossProfitTools.Action === 2)) &&
                                                <select
                                                    className="form-control  text-center"
                                                    value={GrossProfitTools.ChoosePriceList}
                                                    //  onChange={(event) => GrossProfitTools.OnChangePriceList(event.target.value)}
                                                    onChange={(event) => this.OnChangePriceList(event.target.value)}
                                                >
                                                    {PointOfSale &&
                                                        <option key={'-2'} value={'-2'}>Costo promedio </option>
                                                    }
                                                    {!!GrossProfitTools.PricesList && GrossProfitTools.PricesList.length > 0 &&
                                                        GrossProfitTools.PricesList.map((priList, index) => {
                                                            return (
                                                                <option
                                                                    key={index}
                                                                    value={PointOfSale ? priList.ListNum : priList.PriceList}>
                                                                    {priList.ListName}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            }

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className='scrollTableGrossProfit'>
                                                <table className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">Código</th>
                                                            <th className="text-center">Nombre</th>
                                                            <th className="text-center">Precio base</th>

                                                            <th className="text-center">Precio de venta</th>
                                                            <th className="text-center">Cantidad</th>
                                                            <th className="text-center">Ganancia</th>

                                                            <th className="text-center">%Ganancia</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!GrossProfitTools.LinesGrossProfit && GrossProfitTools.LinesGrossProfit.length > 0 &&
                                                            GrossProfitTools.LinesGrossProfit.map((item, index) => {
                                                                return (
                                                                    <tr key={index} style={{ color: `${item.Profit < 0 ? 'red' : 'black'}` }}>
                                                                        <td className="text-center">{item.ItemCode ?? ''}</td>
                                                                        <td className="text-center">{item.Description ?? ''}</td>
                                                                        <td className="text-center">{CURRENCY + ' ' + formatNumber.new(item.BasePrice ?? 0)}</td>

                                                                        <td className="text-center">{CURRENCY + ' ' + formatNumber.new(item.SalePrice ?? 0)}</td>
                                                                        <td className="text-center">{item.Quantity ?? ''}</td>
                                                                        <td className="text-center">{CURRENCY + ' ' + formatNumber.new(item.Profit ?? 0)}</td>

                                                                        <td className="text-center">{`${formatNumber.new(item.PrctProfit ?? 0)} %`}</td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <table className='pr-3 w-100'>
                                    <tbody>
                                        <tr style={{ background: "white" }}>
                                            <td colSpan={4} className="d-none d-md-table-cell" style={{ width: "25vw" }}></td>
                                            <td className="text-center"><strong>Total: </strong></td>
                                            <td className="text-center" style={{ color: `${GrossProfitTools.TotalGrossProfit < 0 ? 'red' : 'black'}` }}><strong>{CURRENCY + ' ' + formatNumber.new(GrossProfitTools.TotalGrossProfit ?? 0)}</strong></td>
                                            <td className="text-center" style={{ color: `${GrossProfitTools.TotPrctGrossProfit < 0 ? 'red' : 'black'}` }}><strong>{`${formatNumber.new(GrossProfitTools.TotPrctGrossProfit ?? 0) ?? ''} %`}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GrossProfitModal;